import React, { useEffect, useState } from 'react'
import ClampLines from 'react-clamp-lines'
import styled from 'styled-components'
import { handleEventLog } from '../../../lib/utils'

const ThemesIdeasMobile = styled.section`
  padding: 20px 0;
  font-family: 'Inter', sans-serif;
  overflow: hidden;
`

const Heading = styled.h2`
  transition: all 0.2s;
  margin-top: 12px;
  text-align: center;
  font-family: 'Hind', 'Inter', sans-serif;
  font-weight: 600;
  font-size: 30px;

  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(13, 21, 54, 0.65);
  @media (max-width: 600px) {
    margin-top: 48px;
    margin-top: 0px;
    font-size: 6vw;
  }
`
const CardsContainerMobile = styled.div`
  display: flex;
  align-items: center;
  padding: 24px;
  overflow: hidden;
  padding-left: 75px;
  @media screen and (max-width: 600px) {
    padding-left: 6vw;
  }
`
const CardsContainer = styled.div`
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  padding: 20px;
  overflow-x: scroll;
`
const ThemesCardMobile = styled.div`
  position: relative;
  border-radius: 14px;
  background: url(${({ img }) => img});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  margin: 16px 3.5px;
  transform: ${({ cardIndex }) => `translateX(${-100 * cardIndex}%)`};
  transition: transform 0.7s ease;
  width: auto;
  height: 430px;
  min-width: 80%;
  @media screen and (max-width: 600px) {
    width: auto;
    min-width: 88vw;
    transform: ${({ cardIndex }) => `translateX(${-90 * cardIndex}vw)`};
  }
`
const ThemeCardHexMobile = styled.div`
  position: relative;
  height: 100%;
  padding: 24px;
  background: ${({ bg }) =>
    `linear-gradient(0deg, ${bg}b3 0%, ${bg}b3 73.2%, ${bg}a6 79.9%, ${bg}7d 89.85%, ${bg}00 100%)`};
  border-radius: 14px;
  width: auto;
  min-width: 80%;
  @media screen and (max-width: 600px) {
    width: auto;
    min-width: 88vw;
  }
`
const ThemeName = styled.div`
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 34px;
  text-transform: uppercase;
  color: #ffffff;
  @media screen and (max-width: 600px) {
    font-size: 6vw;
  }
`
const ThemeHashTags = styled.div`
  font-weight: 400;
  font-size: 12px;
  color: #ffffff;
  margin: 8px 0;
`
const ThemeDescp = styled.div`
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.01em;
  color: #ffffff;
  margin-bottom: 32px;
  .clamp-lines__button {
    display: none;
  }
`
const LinksDiv = styled.div`
  position: absolute;
  bottom: 24px;
  width: 88%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`
const MoreAbout = styled.div`
  display: flex;
  align-items: center;
  background: linear-gradient(154.67deg, #f29d3a 8.53%, #f6c143 85.55%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 0.8em;
  letter-spacing: 0.15px;
  text-transform: capitalize;
  border-bottom: 2px solid #f29d3a;
  cursor: pointer;
`
const JoinNow = styled.button`
  display: flex;
  align-items: center;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.1) 0%,
    rgba(255, 255, 255, 0.05) 100%
  );
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 15px;
  text-align: center;
  color: #ffffff;
  border: none;
  outline: none;
  padding: 6px 14px;
  cursor: pointer;
`
const DotContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin: 0px auto;
  border-radius: 20px;
  max-width: 130px;
  padding: 0 8px;
`
const DardDot = styled.div`
  cursor: pointer;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  transform: scale(${({ isActive }) => (isActive ? 1.4 : 1)});
  justify-content: center;
  align-items: center;
  margin: 8px 0;
  background: ${({ isActive }) =>
    isActive ? 'var(--azure-500)' : 'rgba(13, 21, 54, 0.4);'};
  outline: none;
  border: none;
  transition: all 0.2s;
  font-size: 14px;
`

function ThemesIdeasSection({
  contestData,
  setThemeDetailsOpen,
  handleJoinContestBtn,
}) {
  const isMobile = window.innerWidth < 600
  const [activeCard, setActiveCard] = useState(0)

  useEffect(() => {
    let x = 0
    const runCards = setInterval(() => {
      if (x === contestData.extra_info.themes_data.length) {
        x = 0
      }
      setActiveCard(x)
      x++
    }, 3000)
    return () => {
      clearInterval(runCards)
    }
  }, [])

  const handleThemeHashTags = (hashString) => {
    return '#' + hashString.split(',').join(' #')
  }

  const handleMoreAboutTheme = (theme) => {
    handleEventLog('writer_contest', 'button_click', {
      module_name: 'More About This Theme',
      entity_id: theme.theme_name,
      entity_type: 'theme',
    })
    setThemeDetailsOpen(theme)
    window.location.hash = `#theme=${theme.theme_name}`
  }

  return (
    <ThemesIdeasMobile>
      <Heading> Popular Themes & Ideas </Heading>
      <CardsContainerMobile>
        {contestData?.extra_info?.themes_data.map((theme, index) => (
          <ThemesCardMobile
            key={index}
            cardIndex={activeCard}
            img={theme.image}
          >
            <ThemeCardHexMobile bg={theme.hex_code}>
              <ThemeName>{theme.theme_name}</ThemeName>
              <ThemeHashTags>
                {handleThemeHashTags(theme.hash_tags)}
              </ThemeHashTags>
              <ThemeDescp>
                <ClampLines lines={5} text={theme.description} />
              </ThemeDescp>
              <LinksDiv>
                <MoreAbout onClick={() => handleMoreAboutTheme(theme)}>
                  More About This Theme
                </MoreAbout>
                <JoinNow
                  onClick={() =>
                    handleJoinContestBtn('theme_module', {
                      module_name: 'Join Now',
                      entity_type: 'contest',
                    })
                  }
                >
                  Join Now
                </JoinNow>
              </LinksDiv>
            </ThemeCardHexMobile>
          </ThemesCardMobile>
        ))}
      </CardsContainerMobile>
      {contestData.extra_info?.themes_data.length > 1 && (
        <DotContainer>
          {contestData.extra_info?.themes_data.map((theme, index) => (
            <DardDot isActive={activeCard === index}></DardDot>
          ))}
        </DotContainer>
      )}
    </ThemesIdeasMobile>
  )
}

export default ThemesIdeasSection
